import "./history.css";
import type { Schema } from "./api";
import { actionGroups, actionLabel, authorLabel, contextLine } from "./history";

const moment = (iso: string) => new Date(iso).toLocaleString("ru-RU");

/** Who did what and when, plus the calculation version the event was made at. */
export function EventMeta({ event }: { event: Schema["EventOut"] }) {
  const context = contextLine(event, moment);
  return <>
    <small>
      <span className={`history-action ${event.origin === "system" ? "system" : ""}`}>{actionLabel(event.action)}</span>
      {moment(event.created_at)} · {authorLabel(event)}
    </small>
    {context && <small className="history-context">{context}</small>}
  </>;
}

export type HistoryFilter = { group: string; origin: string };

export function HistoryFilters({ value, change }: { value: HistoryFilter; change: (value: HistoryFilter) => void }) {
  return <div className="history-filters">
    <label>Действие
      <select value={value.group} onChange={e => change({ ...value, group: e.target.value })}>
        <option value="">Все действия</option>
        {actionGroups.map(group => <option key={group.id} value={group.id}>{group.label}</option>)}
      </select>
    </label>
    <label>Кто изменил
      <select value={value.origin} onChange={e => change({ ...value, origin: e.target.value })}>
        <option value="">Специалист и система</option>
        <option value="operator">Только специалист</option>
        <option value="system">Только система</option>
      </select>
    </label>
  </div>;
}
